module.exports = __webpack_public_path__ + "media/images/icons/dollar-sign-741d8a1c7d8c8cf0e1eb98bc294e2130.svg";